import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'

import { Button } from 'hb4e-ui-core-ui'
import { ProductService } from 'hb4e-ui-product'
import { launchDownload } from 'hb4e-ui-download'

import { getProductDetailsForListItem } from '../../../../list-service'

const { isDownloadableProduct, isPDFProduct } = ProductService

const ListItemEPUBDownloadButton = ({ item, list, analyticsOptions }) => {
  const dispatch = useDispatch()
  const { epubProductLink, isExpired } = getProductDetailsForListItem(item)
  const product = item?.product

  if (epubProductLink && isDownloadableProduct(product) && isPDFProduct(product)) {
    const contentURL = epubProductLink?.url
    const analyticsMetaData = {
      eventName: analyticsOptions.eventName,
      eventAction: analyticsOptions.eventAction,
      items: [item],
      listID: list.getServerID(),
      listName: list.getName(),
    }

    const handleDownloadClick = () => {
      dispatch(launchDownload(contentURL, {}, analyticsMetaData))
    }

    return (
      <Button theme="primary outline" onClick={handleDownloadClick} disabled={isExpired}>
        EPUB (ipad/other e-reader)
      </Button>
    )
  }

  return null
}

ListItemEPUBDownloadButton.propTypes = {
  item: PropTypes.object.isRequired,
  list: PropTypes.object.isRequired,
}

ListItemEPUBDownloadButton.defaultProps = {
  analyticsOptions: {
    eventName: 'Item Interaction',
    eventAction: 'Item Download - List',
  },
}

export default ListItemEPUBDownloadButton
